module.exports = __webpack_public_path__ + "img/symbol_glaubeliebehoffnung@2x.f26177b.jpg";